// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3d7G7","item":"PaymentsMobile_item__n6zlK","label":"PaymentsMobile_label__oDCrH","amount":"PaymentsMobile_amount__2wkKA"};